<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>
    <a [routerLink]="['/company']">Company</a>
  </li>
  <li>
    <a [routerLink]="['/company/edit/{companyID}']">{{companyName}}</a>
  </li>
  <li>
    <a [routerLink]="['/company/financeDetails']">Financial Data List</a>
  </li>
  <li>
    Financial Data Input
  </li>
</ul>
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Financial Data Add </strong>
      <button type="button" class="btn btn-sm btn-default btn-back pull-right" data-dismiss="modal" (click)="back()">
        <i class="fa fa-chevron-circle-left"></i>&nbsp;Back
      </button>
      <input id="totalPaidUpShareCapital" type="hidden" value="0" [formControl]="financialDataForm.controls['totalPaid']" />
    </span>
  </div>
  <form>
    <div class="card-block" style="padding:0;">
      <div class="row">
        <div class="col-lg-12">

          
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <div style="width: 100%">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item">
                    <a [ngClass]="[activeclassflag == true ? 'nav-link' : 'nav-link active']"
                    href="javascript: void(0);" data-toggle="tab" data-target="#tabShareCapital"
                    role="tab">Share Capital</a>
                  
                  </li>
                  <li class="nav-item">
                    <a [ngClass]="[activeclassflag == false ? 'nav-link' : 'nav-link active']"
                    href="javascript: void(0);" data-toggle="tab" data-target="#tabReservesAndSurplus"
                    role="tab">Reserves and Surplus</a>
                   
                  </li>
                  <li class="nav-item">
                    <a [ngClass]="[activeclassflag == false ? 'nav-link' : 'nav-link active']"
                    href="javascript: void(0);" data-toggle="tab" data-target="#tabLoansAndInvestments"
                    role="tab">Loans and Investments</a>
                   
                  </li>
                  <li class="nav-item">
                    <a [ngClass]="[activeclassflag == false ? 'nav-link' : 'nav-link active']"
                    href="javascript: void(0);" data-toggle="tab" data-target="#tabBorrowings"
                    role="tab">Borrowings</a>
                  
                  </li>
                  <li class="nav-item">
                    <a [ngClass]="[activeclassflag == false ? 'nav-link' : 'nav-link active']"
                    href="javascript: void(0);" data-toggle="tab" data-target="#tabTemporaryLoans"
                    role="tab">Temporary Loans</a>
                   
                  </li>
                </ul>

                <div class="tab-content">

                  <div class="tab-pane active" id="tabShareCapital" role="tabcard">
                    <div class="card-block">
                      <div id="notify-default">
                        <form [formGroup]="financialDataForm" class="well">
                          <div class="modal-content">
                            <div class="modal-body">
                              <!-- <div class="form-control-label">Amounts only in Rupees with no decimals.</div> -->
                              <div class="row">
                                <div class="col-lg-3">
                                  <label class="form-control-label"><b>Financial Year</b></label>
                                  <span _ngcontent-c2="" style="color: red;">*</span>
                                </div>
                                <div class="col-lg-3">
                                  <div class="form-group" >
                                    <div class="input-group">
                                      <select class="form-control" id="projectKey" [formControl]="financialDataForm.controls['FinancialYear']" style="padding:6px;"
                                        (change)="selectPickerChange();">
                                      <option value="">Select</option>
                                      <option *ngFor="let financialYear of financialYears " [value]=financialYear.name>{{financialYear.name}}</option>
                                    </select>
                                    </div>
                                    <div *ngIf="financialDataForm.controls['FinancialYear'].hasError('required') && financialDataForm.controls['FinancialYear'].touched"
                                      class="form-control-error-custom">
                                      Financial year is required.
                                    </div>
                                  </div>
                                </div>

                              <div class="col-lg-3">
                                <label class="form-control-label">Authorized Equity Share Capital</label>
                              </div>
                                <div class="col-lg-3">
                                  <div class="form-group" >
                                    <input CommaSeperatedNumber  (keypress)="onKeyPress($event)" [formControl]="financialDataForm.controls['authorizedEquityShareCapital']" class="form-control dacimalFix"
                                      style="padding:6px;"  min="0" (keydown)="onlyTwoDecimal($event)"
                                    />
                                  </div>
                                </div>
                              

                             
                                  <div class="col-lg-3">
                                      <label class="form-control-label">Issued Equity Share Capital</label>
                                    </div>
                                 
                                    <div class="col-lg-3">
                                      <div class="form-group">
                                        <input CommaSeperatedNumber [formControl]="financialDataForm.controls['issuedEquityShareCapital']" class="form-control dacimalFix"
                                        style="padding:6px;"(keypress)="onKeyPress($event)" min="0" (keydown)="onlyTwoDecimal($event)">
                                      <div *ngIf="IssuedEquityError.isError" style="color: #fb434a;font-size: 80%;z-index: 1;">
                                        {{ IssuedEquityError.errorMessage }}
                                      </div>
                                      </div>
                                    </div>

                                    <div class="col-lg-3">
                                      <label class="form-control-label">Subscribed Equity Share Capital</label>
                                    </div>
                                    <div class="col-lg-3">
                                      <div class="form-group" >
                                        <input CommaSeperatedNumber id="subscribedEquityShareCapital" [formControl]="financialDataForm.controls['subscribedShareCapital']"
                                          class="form-control dacimalFix" style="padding:6px;" (keypress)="onKeyPress($event)"
                                          min="0" (keydown)="onlyTwoDecimal($event)">
                                        <div *ngIf="SubscribedShareCapital.isError " style="color: #fb434a;font-size: 80%;z-index: 1;">
                                          {{ SubscribedShareCapital.errorMessage }}
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-lg-3">
                                      <label class="form-control-label">Paidup Equity Share Capital</label>
                                    </div>
                                    <div class="col-lg-3">
                                      <div class="form-group" >
                                        <input CommaSeperatedNumber id="paidupEquity" [formControl]="financialDataForm.controls['paidupEquityShareCapital']" class="form-control dacimalFix"
                                          style="padding:6px;" (keydown)="onlyTwoDecimal($event)" min="0" (keypress)="onKeyPress($event)" (input)="paidCalculationAmount();checkfinanceValidation()"
                                          autocomplete="off">
                                        <div id="ErrorPaidupEquityShare" *ngIf="PaidupEquityShareCapital.isError" style="color: #fb434a;font-size: 80%;z-index: 1;">
                                          {{ PaidupEquityShareCapital.errorMessage }}
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-lg-3">
                                      <label class="form-control-label">Authorized Preference Share Capital</label>
                                    </div>
                                    <div class="col-lg-3">
                                      <div class="form-group" >
                                        <input CommaSeperatedNumber [formControl]="financialDataForm.controls['authorizedPreferenceShareCapital']" class="form-control dacimalFix"
                                          style="padding:6px;" (keypress)="onKeyPress($event)" min="0" (keydown)="onlyTwoDecimal($event)">
                                        <!-- <div *ngIf="errors.isError" style="color: #fb434a;font-size: 80%;z-index: 1;">
                                            {{ errors.errorMessage }}
                                          </div> -->
                                      </div>
                                    </div>

                                    <div class="col-lg-3">
                                      <label class="form-control-label">Issued Preference Share Capital</label>
                                    </div>
                                    <div class="col-lg-3">
                                      <div class="form-group" >
                                        <input CommaSeperatedNumber [formControl]="financialDataForm.controls['issuedPreferenceShareCapital']" class="form-control dacimalFix"
                                          style="padding:6px;" (keypress)="onKeyPress($event)" min="0" (keydown)="onlyTwoDecimal($event)">
                                        <div *ngIf="IssuedPreferenceShareCapital.isError" style="color: #fb434a;font-size: 80%;z-index: 1;">
                                          {{ IssuedPreferenceShareCapital.errorMessage }}
                                        </div>
                                      </div>
                                    </div>


                                    <div class="col-lg-3">
                                      <label class="form-control-label">Subscribed Preference Share Capital</label>
                                    </div>
                                    <div class="col-lg-3">
                                      <div class="form-group" >
                                        <input CommaSeperatedNumber [formControl]="financialDataForm.controls['subscribedPreferenceShareCapital']" class="form-control dacimalFix"
                                          style="padding:6px;" (keypress)="onKeyPress($event)" min="0" (keydown)="onlyTwoDecimal($event)">
                                        <div *ngIf="SubscribedPreferenceShareCapital.isError" style="color: #fb434a;font-size: 80%;z-index: 1;">
                                          {{ SubscribedPreferenceShareCapital.errorMessage }}
                                        </div>
                                      </div>
                                    </div>



                                    <div class="col-lg-3">
                                      <label class="form-control-label">Paidup Preference Share Capital</label>
                                    </div>
                                    <div class="col-lg-3">
                                      <div class="form-group" >
                                        <input CommaSeperatedNumber id="paidupPreference" [formControl]="financialDataForm.controls['paidupPreferenceShareCapital']"
                                          class="form-control dacimalFix" style="padding:6px;" min="0" (keypress)="onKeyPress($event)" (keydown)="onlyTwoDecimal($event)"
                                          (input)="paidCalculationAmount();">
                                        <div *ngIf="PaidupPreferenceShareCapital.isError" style="color: #fb434a;font-size: 80%;z-index: 1;">
                                          {{ PaidupPreferenceShareCapital.errorMessage }}
                                        </div>
                                      </div>
                                    </div>


                                    <div class="col-lg-3">
                                      <label class="form-control-label">
                                    <b>Total Paid up Share Capital</b>
                                  </label>
                                    </div>
                                    <div class="col-lg-3">
                                      <div class="form-group" >
                                        <input CommaSeperatedNumber id="totlapaid" [formControl]="financialDataForm.controls['totalPaid']" class="form-control dacimalFix"
                                          placeholder="0" style="padding:6px;" min="0" (keypress)="onKeyPress($event)" (input)="paidCalculationAmount()" (keydown)="onlyTwoDecimal($event)"
                                          readonly value='0'>
                                      </div>
                                    </div>


              </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="tab-pane" id="tabReservesAndSurplus" role="tabcard">
      <div class="card-block">
        <div>
          <form [formGroup]="financialDataForm" class="well">
            <div class="modal-content">
              <div class="modal-body">
                <div class="row">
                  <div class="col-lg-3">
                    <label class="form-control-label">General Reserve</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input id="reverse" CommaSeperatedNumber [formControl]="financialDataForm.controls['generalReserve']" class="form-control dacimalFix ABCD"
                        style="padding:6px;" min="0" (keydown)="onlyTwoDecimal($event)" (keypress)="onKeyPress($event)" (input)="reserveAndSerlusTotalFreeReserves()"
                        autocomplete="off">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Surplus in P & L</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input id="surplus" CommaSeperatedNumber [formControl]="financialDataForm.controls['surplus']" class="form-control dacimalFix ABCD"
                        style="padding:6px;" min="0" (keydown)="onlyTwoDecimal($event)" (keypress)="onKeyPress($event)" (input)="reserveAndSerlusTotalFreeReserves()"
                        autocomplete="off">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Debit Balance in P & L</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber id="debitBalance" [formControl]="financialDataForm.controls['debitBalanceofStatementofProfitandLoss']"
                        class="form-control dacimalFix ABCD" style="padding:6px;" min="0" (keydown)="onlyTwoDecimal($event)"
                        (keypress)="onKeyPress($event)"(input)="reserveAndSerlusTotalFreeReserves()" autocomplete="off">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Others</label>
                    <!-- This Other Is Free Reserve -->
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber id="surplusOthers" [formControl]="financialDataForm.controls['SurplusOthers']" class="form-control dacimalFix ABCD"
                        style="padding:6px;" min="0" (keydown)="onlyTwoDecimal($event)" (keypress)="onKeyPress($event)" (input)="reserveAndSerlusTotalFreeReserves()"
                        autocomplete="off">
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <label class="form-control-label">
                    <b>Total Free Reserves</b>
                  </label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group " >
                      <input CommaSeperatedNumber id="total" [formControl]="financialDataForm.controls['totalFreeReserve']" class="form-control dacimalFix"
                        style="padding:6px;" (input)="reserveAndSerlusTotalFreeReserves()" (keypress)="onKeyPress($event)" placeholder="0"
                        readonly/>
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Capital Reserve (proceeds received in cash)</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber id="capitalReserve" [formControl]="financialDataForm.controls['CapitalReserveCash']" class="form-control dacimalFix EFGHIJ"
                        style="padding:6px;" min="0" (keydown)="onlyTwoDecimal($event)" (keypress)="onKeyPress($event)"(input)="reserveAndSerlusTotalFreeReserves()"
                        autocomplete="off">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Capital Reserve (proceeds not received in cash)</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber id="capitalReserveNotCash" [formControl]="financialDataForm.controls['capitalReserveNotCash']"
                        class="form-control dacimalFix EFGHIJ" style="padding:6px;" min="0" (keydown)="onlyTwoDecimal($event)"
                        (input)="reserveAndSerlusTotalFreeReserves()" (keypress)="onKeyPress($event)" autocomplete="off">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Capital Redemption Reserve (In excess of Preference shares redeemed)</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber id="capitalRedemptionReserve" [formControl]="financialDataForm.controls['capitalRedemptionReserve']"
                        class="form-control dacimalFix EFGHIJ" style="padding:6px;" min="0" (keydown)="onlyTwoDecimal($event)"
                        (input)="reserveAndSerlusTotalFreeReserves()" (keypress)="onKeyPress($event)"autocomplete="off">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Security Premium Reserve</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber id="securityPremiumReserve" [formControl]="financialDataForm.controls['securityPremiumReserve']"
                        class="form-control dacimalFix EFGHIJ" style="padding:6px;" min="0" (keydown)="onlyTwoDecimal($event)"
                        (input)="reserveAndSerlusTotalFreeReserves()"(keypress)="onKeyPress($event)" autocomplete="off">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Others</label>
                    <!-- This Other Is Capital Free Reserve -->
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber id="others" [formControl]="financialDataForm.controls['OthersCapitalReserve']" class="form-control dacimalFix EFGHIJ"
                        style="padding:6px;" min="0" (keydown)="onlyTwoDecimal($event)"(keypress)="onKeyPress($event)" (input)="reserveAndSerlusTotalFreeReserves()"
                        autocomplete="off">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">
                    <b>Total Reserves other than Free Reserves</b>
                  </label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber id="otherthanfreeReserves" [formControl]="financialDataForm.controls['otherthanfreeReserves']"
                        class="form-control dacimalFix" style="padding:6px;" (input)="reserveAndSerlusTotalFreeReserves()"
                        min="0" (keypress)="onKeyPress($event)"(keydown)="onlyTwoDecimal($event)" placeholder="0" readonly value='0'>
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">
                    <b>Total Reserves and Surplus</b>
                  </label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber min="0" id="totalReservesandSurplus" [formControl]="financialDataForm.controls['totalReservesandSurplus']"
                        class="form-control dacimalFix" style="padding:6px;" placeholder="0" (keydown)="onlyTwoDecimal($event)"
                        (input)="reserveAndSerlusTotalFreeReserves()" readonly value='0'>
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">
                    <b>Share Capital and Free Reserves</b>
                  </label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input id="shareCapitalandFreeReserve" CommaSeperatedNumber [formControl]="financialDataForm.controls['shareCapitalandFreeReserves']"
                        class="form-control dacimalFix" style="padding:6px;" placeholder="0" min="0" (keydown)="onlyTwoDecimal($event)"
                        readonly value='0'>
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">
                    <b>Net Worth</b>
                  </label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber id="netWorth" [formControl]="financialDataForm.controls['netWorth']" class="form-control dacimalFix"
                        style="padding:6px;" min="0" (keydown)="onlyTwoDecimal($event)" placeholder="0" readonly>
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Turnover</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber [formControl]="financialDataForm.controls['turnover']" class="form-control dacimalFix" style="padding:6px;"
                        min="0" (keydown)="onlyTwoDecimal($event)" (keypress)="onKeyPress($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Net Profit (For managerial remuneration)</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber [formControl]="financialDataForm.controls['managerialRemunerationNetProfit']" class="form-control dacimalFix"
                        style="padding:6px;" min="0" (keydown)="onlyTwoDecimal($event)" (keypress)="onKeyPress($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Net Profit (For CSR Applicability)</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber [formControl]="financialDataForm.controls['cSRApplicabilityNetProfit']" class="form-control dacimalFix"
                        style="padding:6px;" min="0" (keypress)="onKeyPress($event)"(keydown)="onlyTwoDecimal($event)">
                    </div>
                  </div>
                </div>               
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="tab-pane" id="tabLoansAndInvestments" role="tabcard">
      <div class="card-block">
        <div>
          <form [formGroup]="financialDataForm" class="well">
            <div class="modal-content">
              <div class="modal-body">
                <div class="row">
                  <div class="col-lg-3">
                    <label class="form-control-label">Loans given </label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber min="0" id="loanGiven" (input)="loanAndInvestMent()" [formControl]="financialDataForm.controls['loanGiven']"
                        class="form-control dacimalFix loanAndInvestment" (keypress)="onKeyPress($event)" style="padding:6px;" min="0" (keydown)="onlyTwoDecimal($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Guarantee or security given </label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber min="0" id="guaranteeAmount" [formControl]="financialDataForm.controls['securityofLoan']" class="form-control dacimalFix loanAndInvestment"
                        style="padding:6px;" (input)="loanAndInvestMent()" min="0" (keypress)="onKeyPress($event)" (keydown)="onlyTwoDecimal($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Acquisition of securities</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber min="0" (input)="loanAndInvestMent()" id="acquisitionAmount" [formControl]="financialDataForm.controls['acquisitionCost']"
                        class="form-control dacimalFix loanAndInvestment" (keypress)="onKeyPress($event)" style="padding:6px;" (keydown)="onlyTwoDecimal($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Others</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber min="0" (input)="loanAndInvestMent()" id="loansOthersAmount" [formControl]="financialDataForm.controls['loansOthers']"
                        class="form-control dacimalFix loanAndInvestment" (keypress)="onKeyPress($event)" style="padding:6px;" (keydown)="onlyTwoDecimal($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">
                    <b>Total Loans and Investments (Limits u/s 186)</b>
                  </label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber min="0" [formControl]="financialDataForm.controls['totalLoansandInvestments']" class="form-control dacimalFix loanAndInvestment"
                        style="padding:6px;" placeholder="0" (input)="loanAndInvestMent()" (keypress)="onKeyPress($event)" (keydown)="onlyTwoDecimal($event)"
                        readonly id="totalLoansandInvestment">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="tab-pane" id="tabBorrowings" role="tabcard">
      <div class="card-block">
        <div>
          <form [formGroup]="financialDataForm" class="well">
            <div class="modal-content">
              <div class="modal-body">
                <div class="row">
                  <div class="col-lg-3">
                    <label class="form-control-label">Loans from Bank and Financial Institutions</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input id="loansfromBank" CommaSeperatedNumber [formControl]="financialDataForm.controls['loansfromBankandFinancialInstitutions']"
                        min="0" (input)="borrowingAmount()" (keypress)="onKeyPress($event)" class="form-control dacimalFix" style="padding:6px;"
                        (keydown)="onlyTwoDecimal($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Deferred Payment Liabilities</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input id="deferredPayment" CommaSeperatedNumber [formControl]="financialDataForm.controls['deferredPaymentLiabilities']"
                        class="form-control dacimalFix" min="0" (keypress)="onKeyPress($event)" (input)="borrowingAmount()" style="padding:6px;"
                        (keydown)="onlyTwoDecimal($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Deposits (long term and short term)</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input id="deposits" CommaSeperatedNumber [formControl]="financialDataForm.controls['deposits']" class="form-control dacimalFix"
                        style="padding:6px;" min="0" (keypress)="onKeyPress($event)" (input)="borrowingAmount()" (keydown)="onlyTwoDecimal($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Loans and Advances</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input id="loansandAdvances" CommaSeperatedNumber [formControl]="financialDataForm.controls['loansandAdvancesfromRelatedParties']"
                        min="0" (input)="borrowingAmount()" (keypress)="onKeyPress($event)" class="form-control dacimalFix" style="padding:6px;"
                        (keydown)="onlyTwoDecimal($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Long Term Maturities of Lease Obligations</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input id="longTermMaturities" CommaSeperatedNumber [formControl]="financialDataForm.controls['longTermMaturitiesofLeaseObligations']"
                        min="0" (input)="borrowingAmount()" (keypress)="onKeyPress($event)" class="form-control dacimalFix" style="padding:6px;"
                        (keydown)="onlyTwoDecimal($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Bonds and Debentures</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input id="bondsDebentures" CommaSeperatedNumber [formControl]="financialDataForm.controls['bondsDebentures']" class="form-control dacimalFix"
                        min="0" (input)="borrowingAmount()" (keypress)="onKeyPress($event)" style="padding:6px;" (keydown)="onlyTwoDecimal($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Others</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input id="others" CommaSeperatedNumber [formControl]="financialDataForm.controls['othersBorrowing']" class="form-control dacimalFix"
                        style="padding:6px;" min="0" (input)="borrowingAmount()" (keypress)="onKeyPress($event)" (keydown)="onlyTwoDecimal($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">
                    <b>Total Borrowing (A)</b>
                  </label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input id="totalBorrowing" CommaSeperatedNumber [formControl]="financialDataForm.controls['totalBorrowing']" class="form-control dacimalFix"
                        min="0" (input)="borrowingAmount()" (keypress)="onKeyPress($event)" style="padding:6px;" placeholder="0" (keydown)="onlyTwoDecimal($event)"
                        value="0" readonly>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="tab-pane" id="tabTemporaryLoans" role="tabcard">
      <div class="card-block">
        <div>
          <form [formGroup]="financialDataForm" class="well">
            <div class="modal-content">
              <div class="modal-body">
                <div class="row">
                  <div class="col-lg-3">
                    <label class="form-control-label">Short Term Loans</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber [formControl]="financialDataForm.controls['shortTermLoans']" class="form-control dacimalFix"
                        style="padding:6px;" id="shortTermLoans" (keypress)="onKeyPress($event)" (input)="temporaryLoansAmount()" min="0" (keydown)="onlyTwoDecimal($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Cash Credit Arrangements</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber [formControl]="financialDataForm.controls['cashCreditArrangements']" class="form-control dacimalFix"
                        style="padding:6px;" id="cashCreditArrangements" (keypress)="onKeyPress($event)"(input)="temporaryLoansAmount()" min="0"
                        (keydown)="onlyTwoDecimal($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Discounting of Bills</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber [formControl]="financialDataForm.controls['discountingofBills']" class="form-control dacimalFix"
                        style="padding:6px;" id="discountingofBills" (keypress)="onKeyPress($event)"(input)="temporaryLoansAmount()" min="0"
                        (keydown)="onlyTwoDecimal($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Other Short Term Loans of Seasonal Character</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber [formControl]="financialDataForm.controls['otherShortTermLoansofSeasonalCharacter']" class="form-control dacimalFix"
                        id="otherShortTermLoansofSeasonalCharacter"(keypress)="onKeyPress($event)" style="padding:6px;" min="0" (input)="temporaryLoansAmount()"
                        (keydown)="onlyTwoDecimal($event)">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">Others</label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber [formControl]="financialDataForm.controls['outstandingLoans']" class="form-control dacimalFix"
                        style="padding:6px;" id="outstandingLoans" (keypress)="onKeyPress($event)" min="0" (keydown)="onlyTwoDecimal($event)"
                        (input)="temporaryLoansAmount()">
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">
                    <b>Total Temporary Loans (B)</b>
                  </label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber [formControl]="financialDataForm.controls['totalTemporaryLoans']" class="form-control dacimalFix"
                        style="padding:6px;" id="totalTemporaryLoans" value="0" placeholder="0" (input)="temporaryLoansAmount()"
                        min="0" (keydown)="onlyTwoDecimal($event)" readonly>
                    </div>
                  </div>

                  <div class="col-lg-3">
                    <label class="form-control-label">
                    <b>Borrowing (Limits u/s 180)</b>
                  </label>
                  </div>
                  <div class="col-lg-3">
                    <div class="form-group" >
                      <input CommaSeperatedNumber [formControl]="financialDataForm.controls['borrowing']" class="form-control dacimalFix" style="padding:6px;"
                        min="0" (keydown)="onlyTwoDecimal($event)" id="borrowing" placeholder="0" value="0"
                        readonly>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button id="btnsaveCompany" type="submit" class="btn btn-sm btn-primary pull-right" [disabled]="!financialDataForm.valid || checkValidationInput || disabledOnclick"
        (click)="financialData()"><i class="fa fa-save"></i>&nbsp;Save
  </button>
    </div>
</form>
</section>             

<app-alert></app-alert>